/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import 'emoji-picker-element';

const __vue_script__ = {
	props: {
		beat: Object,
	},
	data() {
		return {
			name: ui_data.current_user.data.display_name,
			email: ui_data.current_user.data.user_email,
			comment: '',
			success: '',
			error: '',
			postId: '',
			comments: [],
			showEmojiPicker: false, // Controls the visibility of the emoji picker
		}
	},
	watch: {
		beat: function(val) {
			this.fetchComments(val);
		},
	},
	mounted() {
		if ( this.beat ) {
			this.fetchComments(this.beat);
		}
		document.addEventListener("click", this.handleClickOutside);
	},
	beforeDestroy() {
    	document.removeEventListener("click", this.handleClickOutside);
  	},
	methods: {
		addEmoji(event) {
			this.comment += event.detail.unicode;
		},
		handleClickOutside(event) {
			const emojiWrapper = this.$refs.emojiPicker?.$el || this.$refs.emojiPicker; // Access the emoji picker via $refs
			const emojiWrapperClick = !!emojiWrapper?.contains(event.target);
			
			if (!emojiWrapperClick && this.showEmojiPicker) {
				this.showEmojiPicker = false;
			}
		},
		getRelativeTime(dateString) {
			const date = new Date(dateString);
			const now = new Date();
			const diffTime = now - date;
			const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
			const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
			const diffMinutes = Math.floor(diffTime / (1000 * 60));

			if (diffMinutes < 1) {
				return 'just now';
			} else if (diffMinutes < 60) {
				return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
			} else if (diffHours < 24) {
				return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
			} else if (diffDays < 30) {
				return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
			} else {
				return date.toLocaleDateString();
			}
		},
		async submitComment(e) {
			e.preventDefault();
			
			try {
				let options = {
					headers: {'X-WP-Nonce': ui_data.nonce},
				}
				const response = await axios.post(`${ui_data.homeUrl}/wp-json/wp/v2/comments`, {
					post: this.beat.id,
					author_name: this.name,
					author_email: this.email,
					content: this.comment,
				}, options);

				// Handle success
				this.success = 'Your comment has been submitted!';
				this.error = '';
				this.comment = '';
				this.fetchComments(this.beat);
			} catch(err) {
				if ( err.response?.data.message ){
					this.error = err.response.data.message;
				}
				this.success = '';
			}
		},
		async fetchComments(val) {
			const response = await axios.get(`${ui_data.homeUrl}/wp-json/wp/v2/comments`, {
				params: {
					post: val.id,
				},
			});
			if ( response && response?.data ) {
				this.comments = response.data;
			}
		}
	},
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"beat-comments"}},[_c('h2',{staticClass:"comment-header"},[_vm._v("Comments")]),_vm._v(" "),_c('form',{on:{"submit":_vm.submitComment}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"comment",attrs:{"required":"","type":"text","name":"comment","placeholder":"Add a comment"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"comment-buttons"},[_c('button',{staticClass:"show-emoji-picker",attrs:{"type":"button","aria-label":"Emoji Picker"},on:{"click":function($event){$event.stopPropagation();_vm.showEmojiPicker = !_vm.showEmojiPicker}}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.showEmojiPicker ? 'Hide' : 'Show'))]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"20","height":"20"}},[_c('path',{attrs:{"fill":"#111","d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}})])]),_vm._v(" "),_c('div',{staticClass:"emoji-picker-wrapper"},[(_vm.showEmojiPicker)?_c('emoji-picker',{ref:"emojiPicker",on:{"emoji-click":_vm.addEmoji}}):_vm._e()],1),_vm._v(" "),_c('button',{staticClass:"post-comment",class:{ disabled: _vm.comment.length === 0 },attrs:{"type":"submit","disabled":_vm.comment.length === 0}},[_vm._v("\n\t\t\t\tComment\n\t\t\t")])])]),_vm._v(" "),(_vm.error)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e(),_vm._v(" "),_c('ol',{staticClass:"comment-list"},_vm._l((_vm.comments),function(comment){return _c('li',{staticClass:"comment",attrs:{"id":("comment-" + (comment.id)),"itemscope":"","itemtype":"https://schema.org/Comment"}},[_c('header',{staticClass:"comment-header"},[(comment.author_avatar_urls)?_c('img',{staticClass:"comment-author-avatar",attrs:{"loading":"lazy","src":comment.author_avatar_urls[96],"alt":"Comment author avatar","height":"96","width":"96"}}):_vm._e()]),_vm._v(" "),_c('div',[_c('strong',{staticClass:"comment-author",attrs:{"itemprop":"author"}},[_vm._v(_vm._s(comment.author_name))]),_vm._v(" "),_c('time',{staticClass:"comment-date",attrs:{"datetime":comment.date}},[_vm._v(_vm._s(_vm.getRelativeTime(comment.date)))]),_vm._v(" "),_c('div',{staticClass:"comment-content",domProps:{"innerHTML":_vm._s(comment.content.rendered)}})])])}),0)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BeatComments.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__